import VideoPlayer from '@/pages/Courses/ClassDetail/Partials/VideoPlayer';
import React from 'react';

interface OnboardingTab {
    id: number;
    title: string;
    description?: string | null;
    video_url?: string | null;
    vimeo_url?: string | null;
}

interface Props {
    tab: OnboardingTab;
}

const OnboardingTabPanel: React.FC<Props> = ({ tab }) => {
    const hasVideo = Boolean(tab.video_url) || Boolean(tab.vimeo_url);

    return (
        <div className="space-y-4">
            {hasVideo ? (
                <div className="overflow-hidden rounded-lg">
                    <VideoPlayer
                        videoUrl={tab.video_url ?? undefined}
                        vimeoUrl={tab.vimeo_url ?? undefined}
                    />
                </div>
            ) : null}
            {tab.description ? (
                <p className="text-sm text-gray-600">{tab.description}</p>
            ) : null}
        </div>
    );
};

export default OnboardingTabPanel;
